import {
  ADD_PROJECT_VALUE_ADDS_URL,
  GET_PROJECT_VALUE_ADDS_URL,
  PATCH_PROJECT_VALUE_ADD_URL,
  PROJECT_REVIEW_HEALTH_API_URL,
} from "../../../config/constants";
import { getAuthHeader } from "../../../config/auth";
import { apiFetch } from "../../../utils/apiClient";



const buildHeaders = () => {
  const authHeader = getAuthHeader();
  return {
    "Content-Type": "application/json",
    ...(authHeader ? { Authorization: authHeader } : {}),
  };
};

/** Searches the project-health endpoint for a single project by id (used to hydrate the review header/leadership tab). */
export async function searchProjectHealthByProjectId(
  projectId,
) {
  const url = new URL(PROJECT_REVIEW_HEALTH_API_URL, globalThis.location.origin);
  url.searchParams.set("page", "0");
  url.searchParams.set("size", "10");
  url.searchParams.set("sortBy", "projectId");
  url.searchParams.set("sortDirection", "asc");
  url.searchParams.set("searchText", projectId);

  const response = await apiFetch(url.toString(), {
    method: "GET",
    headers: buildHeaders(),
  }, "Failed to fetch project health data");

  if (!response.ok) {
    throw new Error(`Failed to fetch project health data (${response.status})`);
  }

  const data = await response.json();
  const projects = Array.isArray(data.projects)
    ? data.projects
    : Array.isArray(data.content)
      ? data.content
      : [];

  return projects[0] ?? null;
}

export async function fetchProjectValueAdds(projectId) {
  const response = await apiFetch(GET_PROJECT_VALUE_ADDS_URL(projectId), {
    method: "GET",
    headers: buildHeaders(),
  }, "Failed to fetch value adds");

  if (!response.ok) {
    throw new Error("Failed to fetch value adds");
  }

  return response.json();
}

export async function addProjectValueAdds(projectId, values) {
  const response = await apiFetch(ADD_PROJECT_VALUE_ADDS_URL(projectId), {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify({ values }),
  }, "Failed to save value add items");

  if (!response.ok) {
    throw new Error("Failed to save value add items");
  }
}

export async function updateProjectValueAdd(
  projectId,
  valueAddId,
  payload,
){
  const response = await apiFetch(PATCH_PROJECT_VALUE_ADD_URL(projectId, valueAddId), {
    method: "PATCH",
    headers: buildHeaders(),
    body: JSON.stringify(payload),
  }, "Failed to update value add");

  if (!response.ok) {
    throw new Error("Failed to update value add");
  }
}

export async function deleteProjectValueAdd(projectId, valueAddId) {
  const response = await apiFetch(PATCH_PROJECT_VALUE_ADD_URL(projectId, valueAddId), {
    method: "PATCH",
    headers: buildHeaders(),
    body: JSON.stringify({ deleted: true }),
  }, "Failed to delete value add");

  if (!response.ok) {
    throw new Error("Failed to delete value add");
  }
}
